import { getValidJWTToken } from '../../services/jwtTokenService';

export const sendCustomerMsgToAgent = async (orgId, chatId, headers) => {
    try {
        // Get valid JWT token (cached or fetch new)
        const jwtToken = await getValidJWTToken();

        // Clone headers and add JWT token
        const headersWithJWT = new Headers(headers.headers);
        headersWithJWT.set('Authorization', `Bearer ${jwtToken}`);

        const optionsWithJWT = {
            ...headers,
            headers: headersWithJWT,
        };

        const data = await fetch(`${process.env.REACT_APP_BACKEND_URL}/live-chat/customer/${orgId}/${chatId}`, optionsWithJWT);
        return data;
    } catch (error) {
        console.error('Error sending customer message to agent:', error.response?.data || error.message);
        throw error;
    }
};

export const endAgentChatRequest = async (orgId, chatId, headers) => {
    try {
        // Get valid JWT token (cached or fetch new)
        const jwtToken = await getValidJWTToken();

        // Clone headers and add JWT token
        const headersWithJWT = new Headers(headers.headers);
        headersWithJWT.set('Authorization', `Bearer ${jwtToken}`);

        const optionsWithJWT = {
            ...headers,
            headers: headersWithJWT,
        };

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/live-chat/end-chat/${orgId}/${chatId}`, optionsWithJWT);
        if (!response.ok) {
            throw new Error('Failed to end the chat');
        }
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error ending the chat:', error.message || error.response?.data);
        throw error;
    }
};

export const submitFeedback = async (orgId, chatId, feedbackValue, headers) => {
    try {
        // Get valid JWT token (cached or fetch new)
        const jwtToken = await getValidJWTToken();

        // Clone headers and add JWT token
        const headersWithJWT = new Headers(headers.headers);
        headersWithJWT.set('Authorization', `Bearer ${jwtToken}`);

        const optionsWithJWT = {
            ...headers,
            headers: headersWithJWT,
        };

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/live-chat/c-s/${orgId}/${chatId}/${feedbackValue}`, optionsWithJWT);
        if (!response.ok) {
            throw new Error('Failed to end the chat');
        }
        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Error ending the chat:', error.message || error.response?.data);
        throw error;
    }
};
